import { getDb } from '../db';
import type { HistoryEntry, UtteranceSource } from '../../core/types';

/**
 * Everything the person has said. Local only, and never handed to
 * `DiagnosticsService` — diagnostics store metadata and no text at all (NFR7).
 * History *is* included in the export, because a backup exists to restore the
 * person's own words.
 */
export const historyRepo = {
  async add(text: string, source: UtteranceSource): Promise<HistoryEntry> {
    const db = await getDb();
    const entry: HistoryEntry = {
      id: crypto.randomUUID(),
      text,
      spokenAt: new Date().toISOString(),
      source,
    };
    await db.put('history', entry);
    return entry;
  },

  async all(): Promise<HistoryEntry[]> {
    const db = await getDb();
    return db.getAllFromIndex('history', 'bySpokenAt');
  },

  /** Newest first. */
  async recent(limit: number): Promise<HistoryEntry[]> {
    const db = await getDb();
    const rows: HistoryEntry[] = [];
    let cursor = await db.transaction('history').store.index('bySpokenAt').openCursor(null, 'prev');
    while (cursor && rows.length < limit) {
      rows.push(cursor.value);
      cursor = await cursor.continue();
    }
    return rows;
  },

  async bulkPut(entries: readonly HistoryEntry[]): Promise<void> {
    const db = await getDb();
    const tx = db.transaction('history', 'readwrite');
    await Promise.all(entries.map((entry) => tx.store.put(entry)));
    await tx.done;
  },
};
